var exports = {
  "rl": "LoadingStatus__6tP9sg",
  "Ph": "managementFooter__HTwcsq",
  "zA": "managementNav__Uz5ugR",
  "Yf": "pinButton__-_OAo4",
  "pc": "navItem__JCwvdD",
  "Cf": "pinnedIcon__MUYVXX",
};

module.exports = exports;
